<template>
  <div class="search">
    <div class="search-center">
      <div class="posRe">
        <input type="text" v-model="searchVal" placeholder="关键词搜索" @keyup.enter="btn"/>
      </div>
      <div class="btn" @click="btn">搜索</div>
    </div>
    <span class="icon-close-btn">
      <i class="icon-img icon-close" @click="closeBtn"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'search',
  props: ['state', 'parameter'],
  data () {
    return {
      searchVal: ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    btn: function () {
      let that = this
      that.$emit('searchBoolBtn', false)
      that.$router.push({
        path: '/searchPage',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            typeId: 0,
            keyWords: that.searchVal,
            cityId: that.parameter.cityId || 0,
            cityIndex: that.parameter.cityIndex,
            countyIndex: -1,
            topIndex: 0
          })),
          '_': new Date().getTime()
        }
      })
      that.searchVal = ''
    },
    closeBtn: function () {
      this.$emit('searchBoolBtn', false)
      this.searchVal = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .search{
    background: #248DDF;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    -webkit-transition: height 0.4s ease-in-out;
    -moz-transition: height 0.4s ease-in-out;
    -ms-transition: height 0.4s ease-in-out;
    -o-transition: height 0.4s ease-in-out;
    transition: height 0.4s ease-in-out;
    z-index: 99;
  }
  .search-hide .search{
    height: 0;
  }
  .search-show .search{
    height: 100px;
  }
  .search::after{
    content:'';
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.2);
  }
  .search>div{
    position: relative;
    z-index: 2;
    width: 80%;
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
  }
  .search-center{
    width: 1200px;
    height: 50px;
    border: 2px solid #DFDFDF;
    border-radius: 50px;
    position: relative;
    font-size: 16px;
    padding-right: 101px;
  }
  .icon-close-btn{
    position: absolute;
    top:20px;
    right: 33px;
    width: 16px;
    height: 16px;
    z-index: 2;
  }
  .icon-close,.icon-val-close{
    display: block;
    width: 100%;
    height: 100%;
    background-position: -324px -15px;
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    -webkit-transition: transform 0.5s;
    -moz-transition: transform 0.5s;
    -ms-transition: transform 0.5s;
    -o-transition: transform 0.5s;
    transition: transform 0.5s;
  }
  .icon-val-close{
    position: absolute;
    width: 16px;
    height: 16px;
    right: 10px;
    top: 50%;
    margin-top: -8px;
    background-size: 700px;
    background-position: -287px -20px;
  }
  .icon-close-btn:hover .icon-close,.icon-val-close:hover{
    background-position: -293px -16px;
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  input{
    display: block;
    width: 100%;
    height: 48px;
    font-weight: 400;
    font-size: 16px;
    color: #fff;
    padding-left:22px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    letter-spacing: 1px;
  }
  input::placeholder{
    color: #CCCCCC;
  }
  .btn{
    cursor: pointer;
    color: #fff;
    width: 90px;
    height: 50px;
    background: #248DDF;
    /*border-radius: 6px;*/
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    line-height: 50px;
    letter-spacing: 2px;
    z-index: 55;
  }
</style>



// WEBPACK FOOTER //
// src/components/search.vue